import { Grid, Paper, Typography } from "@mui/material";

import { Box } from "@mui/system";
import { large } from "constants/space";
import styled from "styled-components";

export const Title = styled(Typography).attrs({
  variant: "h5",
})``;

export const GridHeader = styled(Grid).attrs({ container: true })`
  margin-bottom: 10px !important;
  margin-top: 20px !important;
`;

export const Container = styled(Box)`
  padding: ${large}px;
`;

export const PaperForm = styled(Paper)`
  padding: ${large}px;
`;
